export const ClearFormContext = async (setFormContext) => {
  await setFormContext({})
}
